import {stringifyDate} from '@src/helpers/dates';
import {state as initialState} from './state';
import {IReduxAction, IReduxWorkdayBreak, IReduxWorkdayState} from '@src/@interfaces';
import {
    WORKDAY_FINISH,
    WORKDAY_FINISH_BREAK,
    WORKDAY_RESET,
    WORKDAY_SET,
    WORKDAY_START,
    WORKDAY_START_BREAK,
    WORKDAY_START_LUNCH
} from '@src/_redux/workday/constants';

function finishBreak(state: IReduxWorkdayState): IReduxWorkdayState {
    const breaks = [...state.breaks];
    if (breaks.length) {
        breaks[breaks.length - 1].finished_at = stringifyDate();
    }

    return {
        ...state,
        breaks,
        currentBreak: null,
    };
}

export const reducer = (state: IReduxWorkdayState | undefined, action: IReduxAction): Required<IReduxWorkdayState> => {
    state ??= initialState;

    switch (action.type) {
        case WORKDAY_RESET:
            return {...initialState};

        case WORKDAY_SET:
            return {...state, ...(action?.payload?.details ?? {})};

        case WORKDAY_START:
            return {...state, started_at: action.payload?.startedAt ?? stringifyDate()};

        case WORKDAY_FINISH:
            return {...finishBreak(state), started_at: null, finished_at: null};

        case WORKDAY_START_BREAK:
        case WORKDAY_START_LUNCH:
            if (state.started_at == null) {
                return state;
            }

            const currentBreak: IReduxWorkdayBreak = {
                type: action.type === WORKDAY_START_LUNCH ? 'user-workday@lunch-break' : 'user-workday@break',
                started_at: stringifyDate(),
                finished_at: null,
            };

            return {
                ...state,
                breaks: [...state.breaks, currentBreak],
                currentBreak,
            };

        case WORKDAY_FINISH_BREAK:
            return finishBreak(state);

        default:
            return state;
    }
};
